import React, { Component, ComponentType } from 'react'

export default function asyncComponent(
    // TODO
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    importComponent: any,
    onFetchError: (e: Error) => void
): ComponentType {
    class AsyncComponent extends Component {
        state: any
        constructor(props: any) {
            super(props)

            this.state = {
                component: null
            }
        }

        async componentDidMount() {
            try {
                const { default: component } = await importComponent()
                this.setState({
                    component: component
                })
            } catch (e: any) {
                onFetchError(e)
            }
        }

        render() {
            const C = this.state.component

            return C ? (
                <C {...this.props} />
            ) : (
                <div style={{ minHeight: '100vh' }} />
            )
        }
    }

    return AsyncComponent
}
